import { AppNS } from 'app';

export const saveJob = (job: AppNS.Project): void => {
  localStorage.setItem('newJob', JSON.stringify(job));
};

export const deleteJob = (): void => {
  localStorage.removeItem('newJob');
};

export const getJobById = (id: string): AppNS.Project | null => {
  const job = localStorage.getItem('newJob');
  if (job) {
    const jobData = JSON.parse(job) as AppNS.Project;
    if (id === jobData.id) {
      return jobData;
    }
  }

  return null;
};

export const getJobFromStorage = (): AppNS.Project | null => {
  const job = localStorage.getItem('newJob');
  if (job) {
    return JSON.parse(job) as AppNS.Project;
  }

  return null;
};

export const getStoredJobParams = (): AppNS.Params => {
  const job = getJobFromStorage();
  if (job) {
    return {
      job_id: job.id,
    };
  }
  return {};
};
